import React, { useState } from "react";
import StatusBadge from "../../../shared/StatusBadge";
import XCloseIcon from "../../shared/Icons/XCloseIcon";
import { CopyButton, TextInput } from '@opendate-app/setlist';

const OD_TRACKING_SNIPPET = '<script src="https://app.opendate.io/packs/od_tag.js"></script>';

const OpendateTrackingPixelRow = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <tr>
        <td style={{ paddingLeft: 24 }}>
          <div className="team-member-info">
            <div
              className="team-avatar"
              style={{ borderRadius: 8, overflow: 'hidden' }}
            >
              <img
                src="/Opendate-mark-512.png"
                alt="Opendate"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <div className="team-member-details">
              <span className="team-member-name">Opendate Tracking Pixel</span>
              <span className="team-member-email">First-party visit &amp; referral tracking for accurate marketing sources</span>
            </div>
          </div>
        </td>
        <td>
          <StatusBadge status="info" label="Manual install" />
        </td>
        <td style={{ textAlign: 'right', paddingRight: 24 }}>
          <button
            type="button"
            className="team-btn-secondary"
            style={{ fontSize: 13, padding: '4px 12px' }}
            onClick={() => setShowModal(true)}
          >
            Get Code
          </button>
        </td>
      </tr>
      {showModal && (
        <tr>
          <td colSpan={3} style={{ padding: 0 }}>
            <div className="team-modal-overlay" onClick={() => setShowModal(false)}>
              <div
                className="team-modal"
                style={{ maxWidth: 560, width: '90%', padding: 0, textAlign: 'left' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="team-modal-header">
                  <h3 className="team-modal-title">Opendate Tracking Pixel</h3>
                  <button className="team-modal-close" onClick={() => setShowModal(false)}>
                    <XCloseIcon width="20" height="20" />
                  </button>
                </div>
                <div className="team-modal-body">
                  <p style={{ margin: 0, fontSize: 14, color: 'var(--sl-text-secondary, #414651)', lineHeight: 1.5 }}>
                    Add this tag to the <code>&lt;head&gt;</code> of every page of your website. It lets Opendate
                    attribute ticket sales to the sites that referred your fans (e.g. Google, Bandsintown) — even when
                    they browse several pages before checking out.
                  </p>
                  <p style={{ marginTop: 12, fontSize: 13, color: 'var(--sl-text-quaternary, #717680)', lineHeight: 1.5 }}>
                    Only needed if you embed the Opendate ticket widget on your own site. It's safe to include on every
                    page — it loads once and never overwrites the first referrer it captures.
                  </p>
                  <div className="team-form-group" style={{ marginTop: 16 }}>
                    <TextInput
                      label="Site-wide tag"
                      value={OD_TRACKING_SNIPPET}
                      readOnly
                      style={{ fontFamily: 'monospace' }}
                      trailingButton={<CopyButton value={OD_TRACKING_SNIPPET} />}
                    />
                  </div>
                </div>
                <div className="team-modal-footer">
                  <button className="team-btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default OpendateTrackingPixelRow;
